import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { FrameDataState } from '@/zustand/interfaces/frame-data';
import { inIframe } from '@/utils';

export const useFrameData = create<
  FrameDataState,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      isInIframe: null,
      setIsInIframe: () =>
        set({
          isInIframe: inIframe()
        })
    }),
    {
      name: 'frameData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
